/**
 * اختصار الاسم لعرض كلمة او كلمتين فقط
 * @param {string} name
 * @param {number} maxWords
 */
export const getShortName = (name, maxWords = 2) => {
  if (!name || typeof name !== "string") return "";
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "";
  return parts.slice(0, Math.max(1, Math.min(maxWords, parts.length))).join(" ");
};

/**
 * الحصول على الأحرف الأولى للموظف
 * @param {Object} employee - بيانات الموظف
 * @returns {string} الأحرف الأولى
 */
export const getEmployeeInitials = (employee) => {
  if (employee.name && employee.name.trim().length > 0) {
    const parts = employee.name.trim().split(" ");
    if (parts.length === 1) return parts[0][0].toUpperCase();
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  }
  if (employee.email && employee.email.length > 0) {
    return employee.email[0].toUpperCase();
  }
  return "?";
};
